import { render, staticRenderFns } from "./OfficesIndex.vue?vue&type=template&id=000a585b&scoped=true"
import script from "./OfficesIndex.vue?vue&type=script&lang=js"
export * from "./OfficesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000a585b",
  null
  
)

export default component.exports